/**
 * Product Card Countdown Timer
 * Shows a countdown to midnight when the badge date matches today's date
 * Works with custom.ends_drops (choice) and custom.ends_drops_day (date) metafields
 */

class ProductCountdown {
  constructor() {
    this.badges = [];
    this.init();
  }

  init() {
    // Find all countdown badges with both text and date attributes
    const badgeElements = document.querySelectorAll('.product-card__custom-badge[data-countdown-text][data-countdown-date]');

    console.log('ProductCountdown: Found', badgeElements.length, 'badges');

    badgeElements.forEach(badge => {
      const text = badge.getAttribute('data-countdown-text');
      const dateString = badge.getAttribute('data-countdown-date');

      console.log('ProductCountdown: Processing badge with text:', text, 'date:', dateString);

      const date = this.parseDate(dateString);
      console.log('ProductCountdown: Parsed date:', date);

      if (date) {
        const isToday = this.isToday(date);
        console.log('ProductCountdown: Is today?', isToday, 'Date:', date.toDateString(), 'Today:', new Date().toDateString());

        if (isToday) {
          this.badges.push({
            element: badge,
            textElement: badge.querySelector('.badge-text'),
            originalText: text
          });
        }
      }
    });

    console.log('ProductCountdown: Starting countdown for', this.badges.length, 'badges');

    // Start countdown if we have any badges to update
    if (this.badges.length > 0) {
      this.startCountdown();
    }
  }

  /**
   * Parse date from YYYY-MM-DD format (from Shopify date metafield)
   */
  parseDate(dateString) {
    if (!dateString) return null;

    // Parse YYYY-MM-DD format
    const parts = dateString.split('-');
    if (parts.length !== 3) return null;

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
    const day = parseInt(parts[2], 10);

    return new Date(year, month, day);
  }

  /**
   * Check if date is today
   */
  isToday(date) {
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  }

  /**
   * Calculate time remaining until midnight
   */
  getTimeUntilMidnight() {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0); // Next midnight

    const diff = midnight - now;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return {
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0')
    };
  }

  /**
   * Format countdown text
   * Extracts prefix (e.g., "ENDS IN:" or "DROPS IN:") and appends countdown
   */
  formatCountdown(originalText) {
    const time = this.getTimeUntilMidnight();

    // Extract prefix (everything before the date)
    // originalText format: "ENDS IN: 08.01.26" or "DROPS IN: 08.01.26"
    const prefix = originalText.split(':')[0].trim();

    return `${prefix}: ${time.hours}:${time.minutes}:${time.seconds}`;
  }

  /**
   * Update all badge countdowns
   */
  updateCountdowns() {
    this.badges.forEach(badge => {
      const countdownText = this.formatCountdown(badge.originalText);
      badge.textElement.textContent = countdownText;
    });
  }

  /**
   * Start the countdown interval
   */
  startCountdown() {
    // Update immediately
    this.updateCountdowns();

    // Update every second
    this.interval = setInterval(() => {
      this.updateCountdowns();
    }, 1000);
  }

  /**
   * Stop the countdown (cleanup)
   */
  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize on DOM ready and after a slight delay for dynamic content
function initCountdown() {
  console.log('ProductCountdown: Initializing...');
  if (window.productCountdown) {
    window.productCountdown.destroy();
  }
  window.productCountdown = new ProductCountdown();

  // Re-initialize after a short delay to catch any dynamically loaded content
  setTimeout(() => {
    console.log('ProductCountdown: Re-initializing for dynamic content...');
    if (window.productCountdown) {
      window.productCountdown.destroy();
    }
    window.productCountdown = new ProductCountdown();
  }, 500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdown);
} else {
  initCountdown();
}

// Handle Shopify theme editor section reloads
document.addEventListener('shopify:section:load', initCountdown);

// Handle favorites page dynamic loading
window.addEventListener('favorites:updated', () => {
  console.log('ProductCountdown: Favorites updated, reinitializing...');
  setTimeout(initCountdown, 100);
});

window.addEventListener('favorites:loaded', () => {
  console.log('ProductCountdown: Favorites loaded, reinitializing...');
  setTimeout(initCountdown, 100);
});

// Handle other dynamic content loading with MutationObserver
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      // Check if any added nodes contain product cards with countdown badges
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) { // Element node
          const hasBadge = node.classList?.contains('product-card__custom-badge') ||
                          node.querySelector?.('.product-card__custom-badge[data-countdown-text]');

          if (hasBadge) {
            console.log('ProductCountdown: New badge detected, reinitializing...');
            setTimeout(initCountdown, 50);
            return; // Exit early to avoid multiple reinitializations
          }
        }
      }
    }
  }
});

// Start observing after initial load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true });
  });
} else {
  observer.observe(document.body, { childList: true, subtree: true });
}
